import React, { Component } from "react";

import "react-datepicker/dist/react-datepicker.css";
import API from "../../apiService.js";
import ALERT from "../component/Alert";
import {Form} from "formik";

export class Subjektif extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anamnese: props.patient.anamneses[0]
        ? props.patient.anamneses[0].anamnese
        : "",
      eval: props.patient.anamneses[0] ? props.patient.anamneses[0].eval : "0",
      id: props.patient.anamneses[0] ? props.patient.anamneses[0].id : "",
      nursing_anamnese: props.patient.anamneses[0]
        ? props.patient.anamneses[0].nursing_anamnese
        : "-",
      treat: props.patient.anamneses[0]
        ? props.patient.anamneses[0].treat
        : "-",
      visit_id: props.patient.anamneses[0]
        ? props.patient.anamneses[0].visit_id
        : props.patient.id,
      visit_inpatient_detail_id: props.patient.anamneses[0]
        ? props.patient.anamneses[0].visit_inpatient_detail_id
        : "0",
      wedding_plan: '',
      wedding_number: '',
      last_menstruation: null,
      given_tt_immunization: false,
      tt_immunization_number: 'TT1',
      given_tt_screening: false,
      screening_number: 'TT1',
      year_of_marriage: 0,
      existing_caten: null,
    };
  }

  componentDidMount() {
    this.getExistingCaten()
  }

  getExistingCaten = async () => {
    const res = await API.get(`registration/caten/read/${this.state.visit_id ?? 0}`);
    if (res.code === 200 && res.data.length) {
      this.setState({
        wedding_plan: res.data[0].wedding_plan,
        wedding_number: res.data[0].wedding_number,
        last_menstruation: res.data[0].last_menstruation,
        given_tt_immunization: res.data[0].given_tt_immunization,
        tt_immunization_number: res.data[0].tt_immunization_number,
        given_tt_screening: res.data[0].given_tt_screening,
        screening_number: res.data[0].screening_number,
        year_of_marriage: res.data[0].year_of_marriage,
        existing_caten: res.data[0],
      });
      this.props.onTahunPerkawinanChange(res.data[0].year_of_marriage)
    }
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.patient.anamneses[0] !== prevProps.patient.anamneses[0]) {
      this.setState({
        anamnese: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].anamnese
          : "",
        eval: this.props.patient.anamneses[0] ? this.props.patient.anamneses[0].eval : "0",
        id: this.props.patient.anamneses[0] ? this.props.patient.anamneses[0].id : "",
        nursing_anamnese: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].nursing_anamnese
          : "-",
        treat: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].treat
          : "-",
        visit_id: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].visit_id
          : this.props.patient.id,
        visit_inpatient_detail_id: this.props.patient.anamneses[0]
          ? this.props.patient.anamneses[0].visit_inpatient_detail_id
          : "0",

      })
    }
  }

  handleTextChange = (e) => {
    const name = e.target.name
    let value = e.target.value
    let anamneses = [];
    if (name === 'given_tt_immunization' || name === 'given_tt_screening') {
      value = value === 'true'
    }
    this.setState(
      prevState => ({
        ...prevState,
        [name]: value,
      }),
      () => {
        anamneses = { data: [this.state], param: "anamneses" };
        // console.log(this.state);
        this.props.parentCallback(anamneses);
      }
    );
  };
  handleSubmit = (e) => {
    if (this.state.id > 0) {
      this.PutData();
    } else {
      this.PostData();
    }
    this.PostCaten();
    this.props.nextTab();
  };

  PostCaten = async () => {
    try {
      const d = {
        'id': this.state.existing_caten?.id ?? 0,
        "visit_id" : this.state.visit_id ?? 0,
        "wedding_plan" : this.state.wedding_plan ?? '',
        "wedding_number" : this.state.wedding_number ?? '',
        "last_menstruation" : this.state.last_menstruation || null,
        "given_tt_immunization" : this.state.given_tt_immunization ?? false,
        "tt_immunization_number" : this.state.tt_immunization_number ?? 'TT1',
        "given_tt_screening" : this.state.given_tt_screening ?? false,
        "screening_number" : this.state.screening_number ?? 'TT1',
        'year_of_marriage': this.state.year_of_marriage,
      }
      const res = await API.put('registration/caten/update', d)
      this.props.onCatenSaved(res.data.id)
    }
    catch (e) {
      console.log(e)
    }
  }

  PostData = async () => {
    var param = this.state;
    const res = await API.post("management/anamneses/create", param);
    // console.log(res);
    if (res.code === 200) {
      if (res.code === 200) {
        ALERT("success", "Berhasil Menyimpan Data ");
      } else {
        ALERT("error", "gagal menyimpan data");
      }
    }
  };

  PutData = async () => {
    var param = this.state;
    const res = await API.put("management/anamneses/update", param);
    if (res.code === 200) {
      ALERT("success", "Berhasil Menyimpan Data ");
    } else {
      ALERT("error", "gagal menyimpan data");
    }
  };
  onReload = () => {
    this.props.history.push("/pelayanan");
  };

  render() {
    // console.log(this.props.patient);
    return (
      <>
        <div className="form-group row">
          <label
            htmlFor="example-text-input"
            className="col-md-5 col-form-label col-form-label-sm"
          >
            Anamnese Keperawatan
          </label>
          <div className="col-md-7">
            <div className="row">
              <textarea
                className="form-control form-control-sm"
                type="text"
                placeholder="Keluhan Pasien"
                value={this.state.nursing_anamnese}
                disabled
              />
            </div>
          </div>
        </div>
        <div className="form-group row">
          <label
            htmlFor="example-text-input"
            className="col-md-5 col-form-label col-form-label-sm"
          >
            Anamnese
          </label>
          <div className="col-md-7">
            <div className="row">
              <textarea
                className="form-control form-control-sm"
                type="text"
                placeholder="Keluhan Pasien"
                name="anamnese"
                onChange={this.handleTextChange}
                value={this.state.anamnese}
              />
            </div>
          </div>
        </div>
        <div className="form-group row">
          <label
              htmlFor="example-text-input"
              className="col-md-5 col-form-label col-form-label-sm"
          >
            Rencana Menikah
          </label>
          <div className="col-md-7">
            <div className="row">
              <input
                  className="form-control form-control-sm"
                  type="date"
                  placeholder="Rencana Menikah"
                  name="wedding_plan"
                  defaultValue={this.state.wedding_plan ?? ''}
                  onChange={e => {
                    this.handleTextChange(e)
                    this.props.onTahunPerkawinanChange(e.target.value.split('-')[0])
                  }}
              />
            </div>
          </div>
        </div>
        <div className="form-group row">
          <label
              htmlFor="example-text-input"
              className="col-md-5 col-form-label col-form-label-sm"
          >
            Perkawinan ke
          </label>
          <div className="col-md-7">
            <div className="row">
              <input
                  className="form-control form-control-sm"
                  type="number"
                  placeholder="Perkawinan ke"
                  name="wedding_number"
                  defaultValue={this.state.wedding_number ?? ''}
                  onChange={this.handleTextChange}
              />
            </div>
          </div>
        </div>
        <div className="form-group row">
          <label
              htmlFor="example-text-input"
              className="col-md-5 col-form-label col-form-label-sm"
          >
            Haid Terakhir
          </label>
          <div className="col-md-7">
            <div className="row">
              <input
                  className="form-control form-control-sm"
                  type="date"
                  placeholder="Haid Terakhir"
                  name="last_menstruation"
                  defaultValue={this.state.last_menstruation ?? ''}
                  onChange={this.handleTextChange}
              />
            </div>
          </div>
        </div>
        <div className="form-group row">
          <label
              htmlFor="example-text-input"
              className="col-md-5 col-form-label col-form-label-sm"
          >
            Diberikan Imunisasi TT
          </label>
          <div className="col-md-7">
            <div className="row c0l-md-12">
              <div className="custom-control custom-radio mb-3 col-md-3">
                <input
                    name="given_tt_immunization"
                    className="custom-control-input"
                    id="customRadio5"
                    type="radio"
                    value={true}
                    checked={this.state.given_tt_immunization}
                    onChange={this.handleTextChange}
                />
                <label
                    className="custom-control-label"
                    htmlFor="customRadio5"
                >
                  Ya
                </label>
              </div>
              <div className="custom-control custom-radio mb-3 col-md-3">
                <input
                    name="given_tt_immunization"
                    className="custom-control-input"
                    id="customRadio6"
                    type="radio"
                    value={false}
                    checked={!this.state.given_tt_immunization}
                    onChange={this.handleTextChange}
                />
                <label
                    className="custom-control-label"
                    htmlFor="customRadio6"
                >
                  Tidak
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-md-5 col-form-label col-form-label-sm">
            Imunisasi TT ke
          </label>
          <div className="col-md-7">
            <div className="row">
              <select
                  className="form-control form-control-sm"
                  name="tt_immunization_number"
                  onChange={this.handleTextChange}
                  value={
                    this.state.tt_immunization_number ? this.state.tt_immunization_number : "TT1"
                  }
              >
                <option>-- Pilih --</option>
                <option value="TT1">TT1</option>
                <option value="TT2">TT2</option>
                <option value="TT3">TT3</option>
                <option value="TT4">TT4</option>
                <option value="TT5">TT5</option>
              </select>
            </div>
          </div>
        </div>
        <div className="form-group row">
          <label
              htmlFor="example-text-input"
              className="col-md-5 col-form-label col-form-label-sm"
          >
            Diberikan Screening TT
          </label>
          <div className="col-md-7">
            <div className="row c0l-md-12">
              <div className="custom-control custom-radio mb-3 col-md-3">
                <input
                    name="given_tt_screening"
                    className="custom-control-input"
                    id="customRadio7"
                    type="radio"
                    value={true}
                    checked={this.state.given_tt_screening}
                    onChange={this.handleTextChange}
                />
                <label
                    className="custom-control-label"
                    htmlFor="customRadio7"
                >
                  Ya
                </label>
              </div>
              <div className="custom-control custom-radio mb-3 col-md-3">
                <input
                    name="given_tt_screening"
                    className="custom-control-input"
                    id="customRadio8"
                    type="radio"
                    value={false}
                    checked={!this.state.given_tt_screening}
                    onChange={this.handleTextChange}
                />
                <label
                    className="custom-control-label"
                    htmlFor="customRadio8"
                >
                  Tidak
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-md-5 col-form-label col-form-label-sm">
            Screening ke
          </label>
          <div className="col-md-7">
            <div className="row">
              <select
                  className="form-control form-control-sm"
                  name="screening_number"
                  onChange={this.handleTextChange}
                  value={
                    this.state.screening_number ? this.state.screening_number : "TT1"
                  }
              >
                <option>-- Pilih --</option>
                <option value="TT0">TT0</option>
                <option value="TT1">TT1</option>
                <option value="TT2">TT2</option>
                <option value="TT3">TT3</option>
                <option value="TT4">TT4</option>
                <option value="TT5">TT5</option>
              </select>
            </div>
          </div>
        </div>

        <button className="btn btn-primary" onClick={this.handleSubmit}>
          Simpan
        </button>
        <button className="btn btn-danger" onClick={this.onReload}>
          Tutup
        </button>
      </>
    );
  }
}

export default Subjektif;
